export default __webpack_public_path__ + "static/media/chetna2.e00d9998.png";